interface OrganizationSchema {
  '@context': string
  '@type': string
  'name': string
  'url': string
  'description': string
  'logo'?: string
  'contactPoint'?: {
    '@type': string
    'url': string
  }
  'sameAs'?: string[]
}

export function generateOrganizationSchema(): OrganizationSchema {
  const schema: OrganizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    'name': 'employers.io',
    'url': 'https://employers.io',
    'description':
      'Explore employers.io for powerful job search tools. Find your dream job, apply with ease, and connect with top opportunities.',
    'logo': 'https://employers.io/img/logo.svg',
    'sameAs': [
      'https://www.linkedin.com/company/employers-io',
      'https://twitter.com/employers_io',
      'https://www.facebook.com/employers.io',
      'https://www.instagram.com/employers.io'
    ],
    'contactPoint': {
      '@type': 'ContactPoint',
      'url': 'https://employers.io/employers/contact'
    }
  }

  return schema
}
